export const calculatePercent = (total: number, consumed: number) => ((consumed / total) * 100).toFixed(2);
